import { useState, useEffect, useMemo } from "react";

import { db } from "~/db/db";
import prepareForOptions from "~services/utils/prepareForOptions";

const useSegmentoV2 = (segmentosDisponiveis, grupoSegmento = 0) => {
  const [segmentos, setSegmentos] = useState([]);

  useEffect(() => {
    const fetchSegmentos = async () => {
      let wheres = 0;
      if (!grupoSegmento) return setSegmentos([]);

      let query = db.segmento;

      if (grupoSegmento > 0) {
        query = query.where("grupoSegmentoId").equals(grupoSegmento);
        wheres++;
      }

      if (segmentosDisponiveis) {
        if (wheres > 0) {
          query = query.and((s) => segmentosDisponiveis.includes(s.id));
        } else {
          query = query.where("id").anyOf(segmentosDisponiveis);
        }
      }

      const results = [];
      await query.filter((a) => a.ativo).each((item) => results.push(item));
      setSegmentos(results);
    };

    fetchSegmentos();
  }, [grupoSegmento, segmentosDisponiveis]);

  const optionsSegmento = useMemo(
    () =>
      prepareForOptions(
        (segmentos || []).sort((a, b) => a.nome.localeCompare(b.nome)),
        ["nome"],
        "id"
      ),
    [segmentos]
  );

  return {
    optionsSegmento,
  };
};

export default useSegmentoV2;
